export const breakpoints = {
	base: '0em',
	sm: '30rem', //480px
	md: '48rem', //768px
	lg: '62rem', //992px
	xl: '90rem', //1440px
	'2xl': '120rem', //1920px
}